module.exports = __webpack_public_path__ + "media/images/sponsor__promo-2a1f3242bcf2faf6cbb27df81511effd.png";